import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { rem } from "polished";
import React, { ReactNode, isValidElement } from "react";

import { CenterFlex } from "../base";

interface LogoIconProps {
  children?: ReactNode;
  logo?: JSX.Element | string;
  logoTag?: string;
  backgroundSrc?: string;
  dashed?: boolean;
  noShadow?: boolean;
}

const IconCntr = styled.div`
  position: relative;
`;

const IconBox = styled(CenterFlex)<LogoIconProps>`
  width: ${rem(64)};
  height: ${rem(64)};
  padding: 0;
  background: #fff;

  border: ${rem(0.5)} solid rgba(0, 0, 0, 0.015);
  border-radius: ${rem(15)};
  overflow: hidden;

  & img {
    width: 100%;
  }

  ${({ noShadow }) =>
    !noShadow &&
    css`
      box-shadow: 0px ${rem(3)} ${rem(9)} rgba(0, 0, 0, 0.1);
    `}}

  ${({ dashed }) =>
    dashed &&
    css`
      border: ${rem(3)} dotted rgba(0, 0, 0, 0.2);
    `}
`;

const LogoIcon = ({
  logo,
  logoTag,
  backgroundSrc,
  children,
  ...props
}: LogoIconProps) => {
  let logoComponent = children;
  if (backgroundSrc) {
    return (
      <IconBox
        {...props}
        css={css`
          background-image: url(${backgroundSrc});
          background-size: cover;
        `}
      />
    );
  }
  if (isValidElement(logo)) {
    logoComponent = logo;
  } else if (typeof logo === "string") {
    logoComponent = <img alt="" src={logo} />;
  } else if (logo && "default" in logo) {
    logoComponent = <img alt="" src={logo.default as string} />;
  }

  return (
    <IconCntr>
      <IconBox {...props}>{logoComponent}</IconBox>
      {logoTag ? (
        <img
          alt=""
          css={css`
            position: absolute;
            right: ${rem(-6)};
            bottom: ${rem(-6)};
            width: ${rem(24)};
            height: ${rem(24)};
            border-radius: ${rem(6)};
            box-shadow: 0 ${rem(2)} ${rem(6)} ${rem(0)} rgb(209, 67, 215, 0.3);
          `}
          src={logoTag}
        />
      ) : null}
    </IconCntr>
  );
};

export default LogoIcon;
